import { navigate } from "@gatsbyjs/reach-router";
import { actionsTableListType } from "customHooks/useCompleoSimpleList";
import { apiDirectCall } from "customHooks/useApi/api";
import { useGlobalDialog } from "_ReactContext/GlobalDialogContext";
import useShowMessage from "customHooks/useShowMessage/useShowMessage";

const useActionsTable = (companyId: number, t: any) => {
    const { readyForm, callDialog, agree } = useGlobalDialog();
    const showMessage = useShowMessage();

    return (refreshListFunction: any) => {
        const result: actionsTableListType = [
            {
                icon: "edit",
                tooltip: t("COMPLEOGENERAL_Edit"),
                onClick: (event: any, rowData: any) => {
                    navigate(`/test/edit/${rowData.skGS1pk.split(":")[1]}`);
                }
            },
            {
                icon: "delete",
                tooltip: t("COMPLEOGENERAL_Delete"),
                onClick: async (event: any, rowData: any) => {
                    const uuid = rowData.skGS1pk.split(":")[1];
                    const postAddress = `/test/delete`;

                    callDialog({
                        title: t("TestDelete_ModalTitle"),
                        bodyText: t("TestDelete_Message"),
                        agreeButtonText: t("TestDelete_yes"),
                        disagreeButtonText: t("TestDelete_no"),
                        agreeFunction: async () => {
                            //const uuid = rowData.skGS1pk.split(":")[1];
                            const result = await apiDirectCall(
                                postAddress,
                                "post",
                                {
                                    companyId: companyId,
                                    uuid: uuid
                                }
                            );
                            if (result.status === 200) {
                                showMessage(
                                    t("TestDelete_succesMessage"),
                                    "success"
                                );
                                refreshListFunction();
                                return true;
                            }
                            return false;
                        },
                        disagreeFunction: () => {
                            return false;
                        }
                    });
                }
            },
            {
                icon: "file_copy",
                tooltip: t("COMPLEOGENERAL_CLONE", "Clone"),

                onClick: async (event: any, rowData: any) => {
                    console.log("rowData", rowData);
                    const uuid = rowData.skGS1pk.split(":")[1];
                    navigate(`/test/new/${rowData.testType}/test_${uuid}`);
                }
            }
        ];

        return result;
    };
};

export default useActionsTable;
